import logo from "../assets/logo_Asiakastieto.gif";

export const Header = ({ returnUrl }: { returnUrl: string }) => {
	return (
		<nav>
			<div className="container">
				<div className="row">
					<div className="col-md-3 col-sm-4 col-xs-12">
						<p>
							<a href={returnUrl}>
								<img src={logo} alt="Asiakastieto.fi logo" height="221" width="42" className="logo" />
							</a>
						</p>
					</div>
				</div>
			</div>
		</nav>
	);
};
